import { useQuery } from '@tanstack/react-query'
import type { ScenarioView } from '@/shared/api/__generated__'
import { getScenarioOptions, listScenariosOptions } from './queries'

export interface ScenarioQueryState {
  isPending: boolean
  isError: boolean
  error: Error | null
  refetch: () => void
}

export interface ScenarioListFilter {
  /** Только сценарии этого аккаунта (`?account=`); пусто — весь каталог. */
  account?: string
}

export function useScenarios(
  filter: ScenarioListFilter = {},
): ScenarioQueryState & { scenarios: ScenarioView[] } {
  const query = useQuery(
    listScenariosOptions(filter.account ? { query: { account: filter.account } } : {}),
  )
  return {
    scenarios: query.data?.data ?? [],
    isPending: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: () => void query.refetch(),
  }
}

export function useScenario(
  scenarioId: string,
): ScenarioQueryState & { scenario: ScenarioView | undefined } {
  const query = useQuery({
    ...getScenarioOptions({ path: { id: scenarioId } }),
    enabled: scenarioId !== '',
  })
  return {
    scenario: query.data?.data,
    isPending: query.isPending,
    isError: query.isError,
    error: query.error,
    refetch: () => void query.refetch(),
  }
}
